var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('preguntasexamen',{attrs:{"examen_alumno_id":_vm.examen_alumno_id,"preguntas":_vm.preguntas,"examen_id":_vm.examen_id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }